<!-- Generator: Adobe Illustrator 23.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<svg
  version="1.1"
  id="Layer_1"
  xmlns="http://www.w3.org/2000/svg"
  xmlns:xlink="http://www.w3.org/1999/xlink"
  x="0px"
  y="0px"
  viewBox="0 0 442.6 579.5"
  style="enable-background:new 0 0 442.6 579.5;"
  xml:space="preserve"
>
  <style type="text/css">
    .st0 {
      fill: #a3cd39;
    }
    .st1 {
      fill-rule: evenodd;
      clip-rule: evenodd;
      fill: #7b5634;
    }
  </style>
  <title>logo</title>
  <path
    class="st0"
    d="M364.8,410.4c4.7,0,9.4-0.7,13.9-2.2l0.2-0.1l1.2-0.4l0.3-0.1c0.4-0.1,0.7-0.3,1-0.4l0.6-0.2l0.7-0.3l0.7-0.3
	l0,0l0.5-0.2l0.1-0.1l0.4-0.2l0.4-0.2l0.6-0.3l0.6-0.3l0.9-0.5l0.3-0.1c3.4-2,6.5-4.4,9.3-7.1c13.8-13.8,17-34.9,8.1-52.3l-0.1-0.2
	L404,344c-0.9-1.6-1.8-3.1-2.9-4.5l0,0l-0.3-0.4l-0.6-0.8l-0.1-0.1l-0.3-0.4l-0.4-0.5c-0.2-0.3-0.5-0.6-0.7-0.9l-0.2-0.2
	c-0.3-0.3-0.6-0.6-0.9-1l-0.1-0.1l0,0l-1-1.1l-0.3-0.3l-0.1-0.1l-0.2-0.2l-0.2-0.2h0l-0.3-0.3l0-0.2l-0.2-0.2l-0.2-0.2l-0.1-0.1
	l-0.3-0.3l0,0l-0.3-0.2l-0.1-0.1l-0.2-0.1l-0.3-0.2l0,0l-0.3-0.2l-0.1-0.1l-0.2-0.2l-0.2-0.2l-0.1-0.1l-0.4-0.3l-0.3-0.2l-0.2-0.1
	l-0.4-0.3h0l0,0l0,0l-0.4-0.3l-0.2-0.1l-0.2-0.2h-0.1l-0.3-0.2l-0.1,0l-0.2-0.2l-0.2-0.1l-0.1-0.1l-0.3-0.2l0,0l-0.3-0.2l-0.1-0.1
	l-0.2-0.1l-0.3-0.2l0,0h-0.1l-0.4-0.2l-0.2-0.1l-0.2-0.1l-0.1-0.1l-0.3-0.2l-0.7-0.4l-0.3-0.2l0,0l-0.3-0.2l-0.1-0.1l-0.2-0.1
	l-0.3-0.1H385l-0.4-0.2l0,0h-0.1l-0.3-0.1l0,0l-1.4-0.6l-0.3-0.1h0l-0.4-0.1h-0.1l-0.3-0.1l-0.2-0.1h-0.1l-0.4-0.1
	c-0.7-0.3-1.4-0.5-2.2-0.8l-0.4-0.1c-4.4-1.4-9-2.1-13.6-2.1c-1.4,0-2.9,0.1-4.3,0.2c2.2,7.5,3.7,15.1,4.7,22.8l0.2,0.4
	c0.2,1.6,0.4,3.1,0.5,4.7c2,20.6-0.2,41.4-6.5,61.1C361.3,410.5,363,410.5,364.8,410.4z"
  />
  <path
    class="st0"
    d="M171.5,254.8c5.4,23.7,40.6,75.6,85.4,73.9c-17.6-18.4-48.6-53.5-40.4-77c19-54.7,54.7-90.9,60.3-150.4
	c4-42.8-26.2-70-65.4-101.3c9.5,23.8,23.6,49,22.6,73.2C231.2,138.4,155.9,186.6,171.5,254.8z"
  />
  <path
    class="st0"
    d="M427.6,317.5c-7.1-32.9-21.9-63.7-43.1-89.8c-0.4-0.5-0.8-1-1.2-1.5l0.1-0.1l0,0c-5.8-7-12-13.6-18.6-19.8l0,0
	c-3.6-3.4-2.7-2.6-3.8-3.6s-2.6-2.3-4-3.5l-0.1,0.1l-0.1-0.1l0,0c-1.1-0.9-2.3-1.8-3.5-2.6l-0.4-0.3l0.1-0.1l0,0
	c-14.2-11.3-34.9-8.9-46.2,5.3c-11.1,14-9,34.4,4.9,45.8l0,0l0.1-0.1c17.2,14.1,31,31.8,40.5,52c7.5-1.4,15.2-1.5,22.8-0.4
	c1,0.2,2,0.3,3,0.5c2.2,0.4,4.3,1,6.4,1.6c10.6,3.2,20.3,9,28.1,16.8c2.2,2.1,4.2,4.4,6,6.8c17,23.6,17.2,57.7,0.4,81.4
	c-2,2.6-4.1,5.1-6.4,7.4c-7.8,7.8-17.5,13.6-28.1,16.9c-1.4,0.4-2.8,0.8-4.2,1.1c-1,0.2-2,0.4-3,0.6c-4.1,0.8-8.3,1.2-12.5,1.2
	c-4.8,0-9.6-0.5-14.3-1.5l-0.8,1.5l-0.7,0.3c-4.7,8.9-10.3,17.3-16.7,25l-0.1-0.1l0,0l0.1,0.1c-25.4,30.9-62,50.3-101.8,54.1
	c-16.2,1.6-32.5,0.6-48.3-3c-32.2-7.4-61.1-25.4-82.1-50.9l0.1-0.1l0,0l-0.1,0.1c-6.4-7.8-12-16.2-16.7-25.1l-0.4-0.2
	c-13.7-26.1-19.4-55.5-16.5-84.8c0.1-1.4,0.3-2.7,0.5-4.1l0.3-0.5c3.5-27.9,14.8-54.3,32.5-76.1l0,0c2.1-2.5,4.1-4.9,6.1-7.1
	c2.4-2.6,4.9-5.1,7.6-7.6c0.1-0.1,0.6-0.5,2-1.7c1-0.9,1.9-1.7,2.8-2.5l-0.1-0.1c0.8-0.7,1.7-1.4,2.5-2.1l0.1,0.1l0,0l0.2-0.2l0,0
	c14-11.4,16.1-32,4.6-46c-11.1-13.6-30.9-16-44.9-5.5l-0.1,0.1c-1.8,1-3.4,2.2-4.9,3.5l0,0l-0.1,0.1l-0.1-0.1
	c-1.4,1.2-2.7,2.3-4,3.5s-0.2,0.2-3.8,3.6l0,0c-6.6,6.2-12.8,12.8-18.6,19.8l0.1,0.1C-21.6,312.2-15.2,438.1,64,516.6l0.3-0.1
	c2.1,2,4.2,4,6.4,6c2.3,2.2,4.7,4.2,7.1,6.3l-0.3,0.1l1.6,1.3l-0.1,0.1l0,0l0.1-0.1c79.7,65.6,194.7,65.6,274.3-0.2l0,0l0,0l0,0
	l0.2-0.2l0,0.1l0,0l0,0c2.8-2.3,5.5-4.7,8.1-7.1c31.4-28.5,53.7-65.6,64.1-106.7C447.8,388.2,448.1,346.1,427.6,317.5z"
  />
  <path
    class="st1"
    d="M84.9,340.7h262.4c0.3,1.8,0.6,3.5,0.8,5.3l0.3,2.7l0.1,0.3c0.1,0.5,0.1,1,0.2,1.6
	c7.1,72.2-45.9,137.9-120,145.2c-14.3,1.4-28.8,0.5-42.9-2.7c-64.2-14.9-109-76.3-102.5-142.7c0-0.3,0.1-0.7,0.1-1l0.2-0.5l0.4-2.7
	C84.4,344.4,84.6,342.6,84.9,340.7z"
  />
</svg>
